<template>
    <v-data-table
        small
        :expanded.sync="expanded"
        :single-expand="true"
        :items="metersList"
        :headers="headers"
        item-key="id"
        class="mt-4 meters-table"
        :options.sync="metersListPagination"
        :server-items-length="metersListOptions.size"
        :loading="metersListOptions.loading"
        :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [10, 15, 20, 25] }"
        ref="table"
        :item-class="row_classes"
        dense
    >
        <template #top v-if="$vuetify.breakpoint.xsOnly">
            <MobileTableFilterWrapper v-model="metersListFilter" @submit="metersTableFilterChangeHandler" :defaultFilterData="defaultMetersListFilter">
                <div class="mobile-filter__row">
                    <span class="label font-weight-bold">{{ $t('ID ПУТЭ') }}</span>
                    <v-text-field dense v-model="metersListFilter.meter_rid" outlined hide-details />
                </div>
                <div class="mobile-filter__row">
                    <span class="label font-weight-bold">{{ $t('Номер договора') }}</span>
                    <v-text-field dense v-model="metersListFilter.contract_number_list" outlined hide-details />
                </div>
                <div class="mobile-filter__row">
                    <span class="label font-weight-bold">{{ $t('Номер ПУТЭ') }}</span>
                    <v-text-field dense v-model="metersListFilter.meter_number" outlined hide-details />
                </div>
                <div class="mobile-filter__row">
                    <span class="label font-weight-bold">{{ $t('Тип ПУТЭ') }}</span>
                    <v-select
                        v-model="metersListFilter.meter_type_rid"
                        :items="meterTypes"
                        item-value="meter_type_rid"
                        item-text="meter_type_name"
                        dense
                        hide-details
                        outlined
                        multiple
                    />
                </div>
                <div class="mobile-filter__row">
                    <span class="label font-weight-bold">{{ $t('ПУТЭ ФЛ') }}</span>
                    <v-select :items="puteFLItems" v-model="metersListFilter.pute_fl" dense hide-details outlined></v-select>
                </div>
                <div class="mobile-filter__row">
                    <span class="label font-weight-bold mb-6">{{ $t('Последнее показание') }}</span>
                    <div>
                        <DatePicker
                            :label="$t('Дата с')"
                            dense
                            class="date-filter"
                            outlined
                            :hideDetails="false"
                            v-model="metersListFilter.last_indication_date_from"
                        />
                        <DatePicker
                            :label="$t('Дата по')"
                            class="date-filter"
                            dense
                            outlined
                            :hideDetails="false"
                            :rules="[checkStatusDate(metersListFilter.last_indication_date_from, metersListFilter.last_indication_date_until, hasError)]"
                            v-model="metersListFilter.last_indication_date_until"
                        />
                    </div>
                </div>
            </MobileTableFilterWrapper>
        </template>
        <template #body.prepend>
            <TableFilterWrapper v-if="$vuetify.breakpoint.smAndUp" :filterData="metersListFilter" :changeHandler="metersTableFilterChangeHandler">
                <td>
                    <v-text-field v-model="metersListFilter.meter_rid" />
                </td>
                <td>
                    <v-text-field v-model="metersListFilter.contract_number_list" />
                </td>
                <td>
                    <v-text-field v-model="metersListFilter.meter_number" @change="getMetersList" />
                </td>
                <td>
                    <v-select v-model="metersListFilter.meter_type_rid" :items="meterTypes" item-value="meter_type_rid" item-text="meter_type_name" multiple />
                </td>
                <td>
                    <v-select :items="puteFLItems" v-model="metersListFilter.pute_fl"></v-select>
                </td>
                <td>
                    <RangeDatePicker v-model="metersListFilter" field="last_indication" :label="$t('Последнее показание')" />
                </td>
                <td></td>
            </TableFilterWrapper>
            <table-arrows :table="$refs.table"></table-arrows>
        </template>

        <template v-slot:item.meter_rid="{ item }">
            <table-cell-tooltip :header="headers[0]" :item="item">
                <v-btn class="mr-1" icon @click="expanded.includes(item) ? (expanded = []) : (expanded = [item])">
                    <v-icon :color="$vuetify.theme.themes.dark.primary">{{ expanded.includes(item) ? 'expand_less' : 'expand_more' }}</v-icon>
                </v-btn>
                <span class="link-td" @click="openMeterIndications(item.meter_rid)">{{ item.meter_rid }}</span>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.contract_number_list="{ item }">
            <table-cell-tooltip :header="headers[1]" :item="item">
                <div>{{ item.contract_number_list | replaceDelimiter }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.meter_number="{ item }">
            <table-cell-tooltip :header="headers[2]" :item="item">
                <div class="link-td" @click="openMeterIndications(item.meter_rid)">{{ item.meter_number }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.meter_type_name="{ item }">
            <table-cell-tooltip :header="headers[3]" :item="item">
                <div>{{ item.meter_type_name }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.pute_fl="{ item }">
            <div style="display:flex;justify-content:center;">
                <v-checkbox v-model="item.pute_fl" readonly :color="$vuetify.theme.themes.dark.primary" />
            </div>
        </template>
        <template v-slot:item.last_indication_date="{ item }">
            <table-cell-tooltip :header="headers[5]" :item="item" filter="formatDate">
                <div>{{ item.last_indication_date | formatDate }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.next_meter_verify_date="{ item }">
            <table-cell-tooltip :header="headers[6]" :item="item" filter="formatDate">
                <div>{{ item.next_meter_verify_date | formatDate }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-0">
                <div class="mt-3 ml-4">
                    <span :title="$t('Последнее действие')" class="label mr-3">{{ item.meter_action_name }}:</span>
                    <span :title="$t('Дата последнего действия')" class="label">{{ item.date_meter_action | formatDate }}</span>
                </div>

                <MeterContracts :id="item.meter_rid" :key="item.meter_rid" />
            </td>
        </template>
    </v-data-table>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { cloneObject, isFilterEmpty } from '@/utils';
import translate from '@/utils/translate.util';
import TableCellTooltip from '@/components/ui/TableCellTooltip';
import TableArrows from '@/components/ui/TableArrows';
import MeterContracts from './MeterContracts';
import DatePicker from '@/components/ui/DatePicker';
import FormValidator from '@/mixins/FormValidator';
import TableFilterWrapper from '@/components/ui/TableFilterWrapper';
import MobileTableFilterWrapper from '@/components/ui/MobileTableFilterWrapper';
import RangeDatePicker from '@/components/ui/RangeDatePicker';

export default {
    data: () => ({
        expanded: [],
        hasError: false,
        defaultMetersListFilter: {}
    }),
    components: {
        MeterContracts,
        TableCellTooltip,
        TableArrows,
        TableFilterWrapper,
        MobileTableFilterWrapper,
        RangeDatePicker,
        DatePicker
    },
    mixins: [FormValidator],
    computed: {
        ...mapState('meters', ['metersListOptions']),
        headers() {
            return [
                {
                    text: this.$t('ID ПУТЭ'),
                    value: 'meter_rid'
                },
                {
                    text: this.$t('Номер договора'),
                    value: 'contract_number_list',
                    width: 180
                },
                {
                    text: this.$t('Номер ПУТЭ'),
                    value: 'meter_number'
                },
                {
                    text: this.$t('Тип ПУТЭ'),
                    value: 'meter_type_name'
                },
                {
                    text: this.$t('ПУТЭ ФЛ'),
                    value: 'pute_fl',
                    width: 50
                },
                {
                    text: this.$t('Последнее показание'),
                    value: 'last_indication_date',
                    width: 180,
                    class: 'white-space-normal'
                },
                {
                    text: this.$t('Дата следующей проверки'),
                    value: 'next_meter_verify_date',
                    class: 'white-space-normal'
                }
            ];
        },
        puteFLItems() {
            return [
                { text: this.$t('Все'), value: '2' },
                { text: this.$t('ФЛ'), value: '1' },
                { text: this.$t('ЮЛ'), value: '0' }
            ];
        },
        customDisable() {
            return isFilterEmpty(this.metersListFilter);
        },
        metersList() {
            return translate(this.$store.state.meters.metersList, 'full', this.$i18n.locale);
        },
        meterTypes() {
            return translate(this.$store.state.meters.meterTypes, 'full', this.$i18n.locale);
        },
        metersListFilter: {
            get() {
                return this.$store.state.meters.metersListFilter;
            },
            set(value) {
                this.$store.commit('meters/setMetersListFilter', value);
                this.metersListPagination.page = 1;
                this.getMetersList();
            }
        },
        metersListPagination: {
            get() {
                return this.metersListOptions.pagination;
            },
            set(value) {
                this.metersListOptions.pagination = value;
                this.getMetersList();
            }
        }
    },
    methods: {
        ...mapActions('meters', ['getMetersList', 'getMeterTypes']),
        metersTableFilterChangeHandler() {
            this.metersListPagination.page = 1;
            this.getMetersList();
        },
        openMeterIndications(id) {
            this.$router.push({ name: 'MeterIndications', params: { id } });
        },
        row_classes(item) {
            if (!item.has_indication_in_last_calc_period) return 'colorRow';
        }
    },
    created() {
        this.defaultMetersListFilter = cloneObject(this.metersListFilter);
        this.getMeterTypes();
    },
    mounted() {
        this.$watch(
            '$vuetify.breakpoint.xsOnly',
            (newVal, oldVal) => {
                if (newVal === oldVal) {
                    return;
                }
                if (newVal) {
                    this.metersListPagination.itemsPerPage = 1;
                }
                if (oldVal) {
                    this.metersListPagination.itemsPerPage = 10;
                }
                this.metersListPagination.page = 1;
            },
            { immediate: true }
        );
    }
};
</script>

<style lang="scss">
.v-data-table th {
    white-space: normal !important;
    text-align: start !important;
    vertical-align: top;

    span {
        display: block;
        font-size: 14px;
        padding: 10px 0px;
    }
}
.colorRow {
    //  background-color:rgb(255,139,115, 0.4) ;
    background-color: #ffd1c7;
}
.meters-table .label {
    white-space: normal !important;
}
</style>
